import {LanguageMenuModuleController} from "../language-menu-module.controller";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {COMPONENT_STATES} from "../../../core/consts";
import {LanguageViewModelList} from "../../../apps/website/models/language-view-model-list";
import {action, runInAction} from "mobx"

export class LanguageMenuModuleFetchHandler extends FetchHandler {
  controller: LanguageMenuModuleController;
  languageViewModelList: LanguageViewModelList;

  static injectables = [...LanguageViewModelList.injectables];

  constructor(languageViewModelList: LanguageViewModelList) {
    super()

    this.languageViewModelList = languageViewModelList;
  }

  @action onLoaded() {
    super.onLoaded();

    this.state.navigationManager.registerToCurrentLinkModelChange(() => this.state.isMenuOpen = false);

    runInAction(() => {
      this.state._languages = this.languageViewModelList.languages;
      this.state.selectedLanguage = this.state.appState.language;
      this.state.isMenuOpen = false;
      this.state.type = this.controller.props.type;
    })
  }

  async action() {
    this.store.setComponentState(COMPONENT_STATES.loaded);

    return true;
  }
}
